import { LIST_TEMPLATE, ListTemplateContext } from '@contexts/list-template'
import IconCheck from '@fortuneo/ui-icons/general/IconCheck'
import { clsx } from 'clsx'
import React, { type FC, type PropsWithChildren, useContext } from 'react'

type CustomListItemProps = {
  isOrdered?: boolean
  index?: number
}

export const CustomListItem: FC<PropsWithChildren<CustomListItemProps>> = ({
  children,
  isOrdered = false,
  index = 0,
}) => {
  const listItemTemplate = useContext(ListTemplateContext)

  if (isOrdered && index) {
    return (
      <li
        className="flex list-inside list-none py-2 before:mr-2 before:font-medium before:text-theme-primary-main before:content-[attr(value)]"
        value={index}
      >
        {children}
      </li>
    )
  }

  const isCheckList = listItemTemplate === LIST_TEMPLATE.CHECK
  return (
    <li
      className={clsx(
        'py-2',
        isCheckList
          ? 'ml-8'
          : 'table-row before:table-cell before:content-baseline before:pr-2 before:align-top before:text-130 before:leading-[1.5rem] before:text-theme-primary-main before:content-dot'
      )}
    >
      {isCheckList && (
        <IconCheck className="absolute -ml-8 fill-theme-primary-main" />
      )}
      {children}
    </li>
  )
}
